module.exports = __webpack_public_path__ + "src/img/red-theater/read_theater_performance.06e92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/red-theater/read_theater_performance.jpg
// module id = 129
// module chunks = 0